export class ComplianceRiskVergleichspaare {
  sortiertNachLohndifferenz: ComplianceRiskVergleichspaareEntry[];
  sortiertNachFunktionswertdifferenz: ComplianceRiskVergleichspaareEntry[];
  sortiertNachKonstellationen: ComplianceRiskVergleichspaareEntry[];
  sortiertNachVergleichsperson: ComplianceRiskVergleichspaareEntry[];
  sortiertNachFunktionen: ComplianceRiskVergleichspaareEntry[];
  sortiertNachGeschlecht: ComplianceRiskVergleichspaareEntry[];

  constructor() {
    this.sortiertNachLohndifferenz = [];
    this.sortiertNachFunktionswertdifferenz = [];
    this.sortiertNachKonstellationen = [];
    this.sortiertNachVergleichsperson = [];
    this.sortiertNachFunktionen = [];
    this.sortiertNachGeschlecht = [];
  }
}

export class ComplianceRiskEntry {
  p1Id?: string;
  p1Funktion?: string;
  p1Funktionswert?: number;
  p1Alter?: number;
  p1Dienstjahre?: number;
  p1Gesamtverdienst?: number;
  p2Id?: string;
  p2Funktion?: string;
  p2Funktionswert?: number;
  p2Alter?: number;
  p2Dienstjahre?: number;
  p2Gesamtverdienst?: number;
}
export class ComplianceRiskVergleichspaareEntry extends ComplianceRiskEntry {
  p1Geschlecht: string;
  p2Geschlecht: string;
  test1nachRaengen: number;
  test2NachRegression: number;
  test3NachLohnunterschieden: number;
  negativeLohndifferenz: number;
  negativeLohndifferenzInProzent: string;
  differenzFunktionswert: number;
  scoreDerKonstellation: number;
  lohnDifferenzDerKonstellation: number;

  constructor(generate = false) {
    super();
    if (generate) {
      this.p1Id = 'p1Id';
      this.p1Funktion = 'p1Funktion';
      this.p1Funktionswert = 0;
      this.p1Alter = 0;
      this.p1Dienstjahre = 0;
      this.p1Gesamtverdienst = 0;
      this.p2Id = 'p2Id';
      this.p2Funktion = 'p2Funktion';
      this.p2Funktionswert = 0;
      this.p2Alter = 0;
      this.p2Dienstjahre = 0;
      this.p2Gesamtverdienst = 0;
      this.test1nachRaengen = 0;
      this.test2NachRegression = 0;
      this.test3NachLohnunterschieden = 0;
      this.p1Geschlecht = 'p1Geschlecht';
      this.p2Geschlecht = 'p2Geschlecht';
      this.negativeLohndifferenz = 0;
      this.negativeLohndifferenzInProzent = 'negativeLohndifferenzInProzent';
      this.differenzFunktionswert = 0;
      this.scoreDerKonstellation = 0;
      this.lohnDifferenzDerKonstellation = 0;
    }
  }
}
